/* eslint-disable no-unused-vars */
import { makeStyles } from "@mui/styles";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";

const useStyles = makeStyles(styles);

export default function PurchaseAndSaleBDept() {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);

  useEffect(() => {
    loadDataFromServer();
  }, []);

  async function loadDataFromServer() {
    try {
      const { data } = await API.post("/report/analytics", {
        template: "reports/analytics/dashboard/10_days_sale_purchase_dept",
      });
      console.log(data);

      setOptions({
        title: {
          text: "Sale / Purchase By Department (Last 10 Days)",
        },
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: data.labels,
        },

        fill: {
          opacity: 1,
        },
      });
      setSeries([
        {
          name: "Sale",
          data: data.series1,
        },
        {
          name: "Purchase",
          data: data.series2,
        },
      ]);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={210}
      />
    </div>
  );
}
